import Reveal from 'components/ui/Reveal';
import SectionHeading from 'components/ui/SectionHeading';
import { Package, Sparkles, Clock, Shield } from 'lucide-react';
import { PRODUCT } from 'lib/constants';

export default function ProductDetails() {
  const details = [
    {
      title: 'Product',
      value: PRODUCT?.name || 'Singaraa Dry Roasted Peanuts',
      icon: Package
    },
    {
      title: 'Taste',
      value: 'Nutty • Crunchy • Naturally Delicious',
      icon: Sparkles
    },
    {
      title: 'Best For',
      value: 'Office Snacks • Travel • Evening Craving • Everyday Munching',
      icon: Clock
    },
    {
      title: 'Packaging',
      value: 'Carefully packed for freshness.',
      icon: Shield
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-singaraa-beige/40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20">
        <Reveal>
          <SectionHeading
            eyebrow="SPECIFICATIONS"
            title="Premium Product Details"
            subtitle="Every detail crafted with utmost precision for quality and freshness"
            className="mb-8 sm:mb-12 md:mb-14"
          />
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {details.map((detail, index) => (
            <Reveal key={index} delay={index * 0.1} className="h-full">
              <div className="group relative bg-white p-5 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl border border-singaraa-beige shadow-sm hover:shadow-xl transition-all duration-500 ease-out hover:-translate-y-1.5 overflow-hidden h-full flex flex-col">
                <div className="absolute top-0 left-0 w-full h-1 bg-singaraa-caramel transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out origin-left"></div>
                <div className="mb-4 sm:mb-6 bg-singaraa-cream w-12 sm:w-14 md:w-16 h-12 sm:h-14 md:h-16 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-500 ease-out text-singaraa-caramel shrink-0">
                  <detail.icon className="w-6 sm:w-7 md:w-8 h-6 sm:h-7 md:h-8" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-lg sm:text-xl md:text-2xl text-singaraa-dark mb-2 sm:mb-3 group-hover:text-singaraa-caramel transition-colors font-semibold">
                  {detail.title}
                </h3>
                <p className="font-body text-singaraa-brown/80 text-sm sm:text-base leading-relaxed flex-1">
                  {detail.value}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
